if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.viewport = this.querySelector('[role="document"]');
      this.position = { x: .5, y: .5 };
      this.viewport.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') this.setZoom(true);
      });
      this.viewport.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') this.setZoom(false);
      });
      this.viewport.addEventListener('pointerdown', (event) => {
        if (!this.image || event.pointerType === 'mouse') return;
        this.setZoom(true);
        this.drag = { x: event.clientX, y: event.clientY, ...this.offset };
        this.viewport.setPointerCapture(event.pointerId);
      });
      this.viewport.addEventListener('pointermove', (event) => {
        if (!this.image) return;
        if (event.pointerType === 'mouse' && !this.zoomed) this.setZoom(true);
        if (!this.zoomed) return;
        const box = this.viewport.getBoundingClientRect();
        if (event.pointerType === 'mouse') {
          this.position.x = Math.max(0, Math.min(1, (event.clientX - box.left) / box.width));
          this.position.y = Math.max(0, Math.min(1, (event.clientY - box.top) / box.height));
        } else if (this.drag) {
          const dx = Math.max(0, this.imageWidth - box.width);
          const dy = Math.max(0, this.imageHeight - box.height);
          this.position.x = dx ? Math.max(0, Math.min(1, -(this.drag.left + event.clientX - this.drag.x) / dx)) : .5;
          this.position.y = dy ? Math.max(0, Math.min(1, -(this.drag.top + event.clientY - this.drag.y) / dy)) : .5;
        }
        this.paint();
      });
      const stopDrag = () => { this.drag = null; };
      this.viewport.addEventListener('pointerup', stopDrag);
      this.viewport.addEventListener('pointercancel', stopDrag);
      this.viewport.addEventListener('keydown', (event) => {
        const movement = { ArrowLeft: [-.1, 0], ArrowRight: [.1, 0], ArrowUp: [0, -.1], ArrowDown: [0, .1] }[event.key];
        if (!movement || !this.image) return;
        event.preventDefault();
        this.setZoom(true);
        this.position.x = Math.max(0, Math.min(1, this.position.x + movement[0]));
        this.position.y = Math.max(0, Math.min(1, this.position.y + movement[1]));
        this.paint();
      });
      this.resizeObserver = new ResizeObserver(() => this.layout());
    }
    connectedCallback() {
      super.connectedCallback();
      this.resizeObserver.observe(this.viewport);
    }
    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    hide() {
      this.drag = null;
      this.setZoom(false);
      super.hide();
    }
    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      const media = [...this.viewport.children].filter(element => element.hasAttribute('data-media-id'));
      const active = media.find(element => element.dataset.mediaId === id);
      if (!active) return;
      media.forEach(element => element.classList.toggle('active', element === active));
      this.image = active.tagName === 'IMG' ? active : null;
      this.position = { x: .5, y: .5 };
      this.viewport.scrollTop = this.viewport.scrollLeft = 0;
      if (this.image) {
        this.image.removeAttribute('srcset');
        this.image.src = this.image.dataset.zoomSrc;
        this.image.draggable = false;
      } else {
        active.loadContent?.();
      }
      this.setZoom(false);
    }
    setZoom(enabled) {
      this.zoomed = Boolean(enabled && this.image);
      this.viewport.classList.toggle('is-zoomed', this.zoomed);
      this.layout();
    }
    layout() {
      if (!this.image || !this.hasAttribute('open')) return;
      const width = Number(this.image.dataset.zoomWidth);
      const height = Number(this.image.dataset.zoomHeight);
      if (!width || !height) return;
      const fittedScale = Math.min(this.viewport.clientWidth / width, this.viewport.clientHeight / height, 1);
      const scale = this.zoomed ? Math.max(1, fittedScale * 3) : fittedScale;
      this.imageWidth = width * scale;
      this.imageHeight = height * scale;
      this.image.style.width = `${this.imageWidth}px`;
      this.image.style.height = `${this.imageHeight}px`;
      this.paint();
    }
    paint() {
      if (!this.image) return;
      const dx = this.viewport.clientWidth - this.imageWidth;
      const dy = this.viewport.clientHeight - this.imageHeight;
      this.offset = { left: dx < 0 ? dx * this.position.x : dx / 2, top: dy < 0 ? dy * this.position.y : dy / 2 };
      this.image.style.transform = `translate3d(${this.offset.left}px,${this.offset.top}px,0)`;
    }
  });
}
